var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5PointsHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a80cb4ba-645e-459e-9802-9591f51d808d",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "e53795ff-3081-4431-9b96-f0e858784ae1",
    cx: 62,
    cy: 56.44,
    r: 4.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e53795ff-3081-4431-9b96-f0e858784ae1",
    cx: 62,
    cy: 77.44,
    r: 4.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "e53795ff-3081-4431-9b96-f0e858784ae1",
    d: "M98.38,24.28H29.63a13.51,13.51,0,0,0-13.5,13.5V96.53A13.51,13.51,0,0,0,29.63,110H98.38a13.52,13.52,0,0,0,13.5-13.5V37.78A13.51,13.51,0,0,0,98.38,24.28Zm10.5,72.25A10.51,10.51,0,0,1,98.38,107H29.63a10.51,10.51,0,0,1-10.5-10.5V68.65H38.44a8.71,8.71,0,0,1,6.42,2.53c1.69,1.78,2.5,4.43,2.34,7.65-.26,5-4,8.84-8.76,8.84a8.77,8.77,0,0,1-8.76-8.76h-3A11.78,11.78,0,0,0,38.44,90.67c6.36,0,11.41-5,11.75-11.68.21-4.07-.88-7.48-3.16-9.88-.15-.16-.32-.3-.49-.46H76.63V79.5a11.75,11.75,0,0,0,23.5,0V68.65h8.75ZM97.13,68.65V79.5a8.75,8.75,0,0,1-17.5,0V68.65Zm-17.5-3V53a8.75,8.75,0,0,1,17.5,0V65.65Zm29.25,0h-8.75V53a11.75,11.75,0,0,0-23.5,0V65.65H31.68V44.5h16v-3h-19l0,24.15H19.13V37.78a10.51,10.51,0,0,1,10.5-10.5H98.38a10.51,10.51,0,0,1,10.5,10.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5PointsHome);
export default __webpack_public_path__ + "static/media/5-points-home.59ff9f984e136968ad079bb8f93551f0.svg";
export { ForwardRef as ReactComponent };